import { telemetryService } from 'ci-common-ui';

const { ILevel, IEvent, eventLevels, eventAction } = telemetryService;

export { ILevel, IEvent, eventLevels, eventAction };
